import {
  createDonation as createDonationApi
  , createGuestDonation as createGuestDonationApi
  , getRecentDonations as getRecentDonationsApi
  , getFamilyDonations as getFamilyDonationsApi
  , getCategoryDonations as getCategoryDonationsApi
  , updateDonation as updateDonationApi
  , queryFamilyForDonation as queryFamilyForDonationApi
  , queryGuestForDonation as queryGuestForDonationApi

} from "./SpatApi";
import { showErrorToast, showSuccessToast } from "../utils/Toasts";

// Fetch recent families
export async function getRecentDonations() {
  try {
    const response = await getRecentDonationsApi();
    if (response?.status === 200) {
      return response.data;
    } else {
      showErrorToast(response?.data?.message || response?.message || "Failed to fetch recent Donations");
    }
  } catch (error) {
    showErrorToast("Error fetching recent Donations.");
  }
}

// Create a new 

export async function createDonation(data) {
  try {
    const response = await createDonationApi(data);
    const status = response?.status;
    const message = response?.data?.message || response?.message;

    if (status === 200 || status === 201) {
      showSuccessToast(message || "Donation created successfully.");
      return true;
    }

    // We may never reach here if Axios throws for 409!
    else if (message === "Donation already exists for this familyId") {

      showSuccessToast(message || "Donation already exists.");
      return 409;
    }

    showErrorToast(message || "Something went wrong while creating the donation.");
    return false;

  } catch (error) {
    const status = error?.response?.status;
    const message = error?.response?.data?.message || error?.message;

    if (status === 409) {
      showSuccessToast(message || "Donation already exists.");
      return true;
    }

    showErrorToast(message || "Something went wrong while creating the donation.");
    return false;
  }
}


export async function createGuestDonation(data) {
  try {
    const response = await createGuestDonationApi(data);
    const status = response?.status;
    const message = response?.data?.message || response?.message;

    if (status === 200 || status === 201) {
      showSuccessToast(message || "Donation created successfully.");
      return true;
    }

    // We may never reach here if Axios throws for 409!
    else if (message === "Donation already exists for this familyId") {

      showSuccessToast(message || "Donation already exists.");
      return 409;
    }

    showErrorToast(message || "Something went wrong while creating the donation.");
    return false;

  } catch (error) {
    const status = error?.response?.status;
    const message = error?.response?.data?.message || error?.message;

    if (status === 409) {
      showSuccessToast(message || "Donation already exists.");
      return true;
    }

    showErrorToast(message || "Something went wrong while creating the donation.");
    return false;
  }
}

// Fetch  by ID
export async function getFamilyDonations(data) {
  try {
    const response = await getFamilyDonationsApi(data);
    if (response?.status === 200) {
      return response.data;
    } else {
      showErrorToast(response?.data?.message || response?.message || "Failed to fetch Family  Donation data");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error fetching Family Donation details");
    return false;
  }
}

export async function getCategoryDonations(data) {
  try {
    const response = await getCategoryDonationsApi(data);
    if (response?.status === 200) {
      return response.data;
    } else {
      showErrorToast(response?.data?.message || response?.message || "Failed to fetch Category  Donation data");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error fetching Category Donation details");
    return false;
  }
}
// Update  details
export async function updateDonation(updatedDonationData) {
  try {
    const response = await updateDonationApi(updatedDonationData);
    if (response?.status === 200 || response?.status === 201) {
      showSuccessToast("Donation updated successfully");
      return true; // Return true on success
    } else {
      showErrorToast(response?.data?.message || response?.message || "Something went wrong while updating Donation");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error updating Donation");
    return false;
  }
}

export async function queryFamilyForDonation(data) {
  try {
    const response = await queryFamilyForDonationApi(data);
    if (response?.status === 200) {
      return response.data;
    }
    else if (response?.status === 404 || response?.success === false) {
      return false;
    }
    else {
      showErrorToast(response?.data?.message || response?.message || "Failed to fetch family data");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error fetching family details");
    return false;
  }
}

export async function queryGuestForDonation(data) {
  try {
    const response = await queryGuestForDonationApi(data);
    if (response?.status === 200) {
      return response.data;
    }
    else if (response?.status === 404 || response?.success === false) {
      return false;
    }
    else {
      showErrorToast(response?.data?.message || response?.message || "Failed to fetch family data");
      return false;
    }
  } catch (error) {
    showErrorToast(error?.message || "Error fetching family details");
    return false;
  }
}